import ExcelJS from "exceljs";
import { useTripStore } from "../../store/useTripStore";
import { formatDateTime, formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";

export const ExportSATTripReport = (data) => {
  const {
    tripDetails,
  } = useTripStore();

  const downloadExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      data.data.FromDateTime && data.data.ToDateTime ? `(${formatDateTimeWithoutSec(data.data.FromDateTime)} to ${formatDateTimeWithoutSec(data.data.ToDateTime)}) (at ${getCurrentDateTime1()})` : "";
    // Determine report type based on the "circle" flag
    const reportTitle = `${data?.data?.circleName || ""} ${data?.data?.zoneName || ""} ${data?.data?.wardName || ""} ${data?.data?.colName} ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Circles");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    // Merge cells across 10 columns (adjust if needed)
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 11);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle,]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 11);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Vehicle Number",
      "TS Name",
      "Driver Name",
      "Contact No",
      "SFA Name",
      "SFA Contact No",
      "Trips to TS/SCTP",
      "Reported Time",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    tripDetails.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.zone?? "N/A",
        item.circle?? "N/A",
        item.ward?? "N/A",
        item.vehicleType?? "N/A",
        item.vehicleNumber?? "N/A",
        item.transferStationName?? "N/A",
        item.driverName?? "N/A",
        item.driverNumber?? "N/A",
        item.primaryDeploymentInchargeName?? "N/A",
        item.primaryDeploymentInchargeMobileNumber?? "N/A",
        item.trips?? "N/A",
        formatDateTime(item.scannedDateTime),
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 15 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 20 },
      { width: 20 },
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${data.data.circleName || ""}${data.data.zoneName || ""}${data.data.wardName || ""}TripReport.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <button
      type="reset"
      className="btn btn-excel"
      onClick={downloadExcel}
    >
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
  )
}